
const FormInputNumber = ({ style = {}, name, label, register, errors, min = 0, max = 9000000, disabled, helperText }) => {
    return (

        <div className="form-input" style={style}>
            <label htmlFor={name}>{label}</label>
            <input {...register(name, {
                setValueAs: (value) => Number(value)
            })}
                style={{ height: "48px" }}
                type="number"
                id={name} min={min} max={max}
                disabled={disabled}
            />
            {helperText && <p style={{ padding: '.4rem .6rem' }}>{helperText}</p>}
            {errors[name] && <p style={{ color: "var(--red)", paddingTop: ".4rem" }}>{errors[name]?.message}</p>}
        </div>
    )
}

export default FormInputNumber